import { Button, HeadTitle, Spacer, TextField } from 'oui';
import { FloatingBox, SideBox } from '../../etc/LBox/LBox';
import { useMtgConditions } from '../../../application/bloc/useMtgConditions';
import { useMtgCredit } from '../../../application/bloc/useMtgCredit';

export const MtgCredit = () => {
  const { navigateNextStep, mortgageInfo, onChangeInput, saveInputInfoTemp } =
    useMtgConditions();
  const { isActive, sendBeaconClkBtnNext, warning, validateCreditPoint } =
    useMtgCredit();

  const onClickButton = () => {
    void saveInputInfoTemp();
    navigateNextStep('PUSH');
    sendBeaconClkBtnNext();
  };
  return (
    <>
      <HeadTitle textTitle={'신용점수를 입력해주세요'} />
      <Spacer size={'xs'} />
      <SideBox>
        <TextField
          value={mortgageInfo.credPoint ?? ''}
          adornment={'점'}
          inputMode={'numeric'}
          state={'enabled'}
          placeholder={'신용점수(예.900)'}
          warning={warning}
          onChangeTextInput={(value) => {
            if (validateCreditPoint(value)) {
              onChangeInput({ key: 'credPoint', value });
            }
          }}
        />
      </SideBox>
      <FloatingBox>
        <Button
          flexible={true}
          configuration={'contained'}
          isDisabled={!isActive}
          state={isActive ? 'enabled' : 'disabled'}
          children={'다음'}
          onClick={onClickButton}
        />
      </FloatingBox>
    </>
  );
};
